import { render, staticRenderFns } from "./SOSListPricing.vue?vue&type=template&id=3657795f"
import script from "./SOSListPricing.vue?vue&type=script&lang=js"
export * from "./SOSListPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports